/**
 * GENERATED FILE — do not edit by hand.
 *
 * Rebuild with `npm --prefix web run words`; the generator, and the reasoning
 * behind which words land where, is in ../__tools/build-words.mjs.
 *
 * Derived from SCOWL (Spell Checker Oriented Word Lists) via the
 * `wordlist-english` package. SCOWL is Copyright 2000-2016 by Kevin Atkinson
 * and is used under its permissive licence, which asks that this notice travel
 * with the words:
 *
 *   Permission to use, copy, modify, distribute and sell these word lists, the
 *   associated scripts, the output created from the scripts, and its
 *   documentation for any purpose is hereby granted without fee, provided that
 *   the above copyright notice appears in all copies and that both that
 *   copyright notice and this permission notice appear in supporting
 *   documentation. Kevin Atkinson makes no representations about the
 *   suitability of this array for any purpose. It is provided "as is" without
 *   express or implied warranty.
 *
 * Stored as newline-joined strings rather than arrays of strings: same bytes on
 * the wire minus two quotes and a comma per word, and the only thing either one
 * is ever turned into is a Set.
 */

/** Words the game will pick as an answer: common enough to be findable. */
export const ANSWERS = `able
acid
aged
akin
ally
also
arch
area
army
atom
aunt
away
axis
baby
back
bake
ball
band
bang
bank
bare
bark
base
bash
bass
bath
baud
beam
bean
bear
beat
beef
been
beer
bell
belt
bend
bent
best
beta
bias
bill
bind
bird
bite
blew
blob
blow
blue
boat
body
boil
bold
bolt
bomb
bond
bone
book
boom
boot
bore
born
boss
both
bout
bowl
bred
buck
bulb
bulk
bull
bump
burn
bury
bush
buss
bust
busy
byte
cage
cake
call
calm
came
camp
cant
card
care
case
cash
cast
cave
cell
cent
chap
char
chat
chew
chip
chop
cite
city
clip
clog
club
clue
coal
coat
code
coin
coke
cold
come
cook
cool
cope
copy
core
corn
cost
crew
crop
cube
cult
cums
cure
cute
daft
damp
dare
dark
dash
data
date
dawn
dead
deaf
deal
dear
debt
deck
deed
deem
deep
defy
deny
desk
dial
dice
died
diet
dine
dire
dirt
disc
dish
disk
dive
dole
done
doom
door
dose
down
drag
draw
drew
drip
drop
drug
drum
dual
duck
duff
dull
duly
dumb
dump
dust
duty
each
earn
ease
east
easy
echo
edge
edit
else
emit
envy
epic
ergo
even
ever
evil
exam
exit
face
fact
fail
fair
fake
fall
fame
fare
farm
fast
fate
fear
feat
feed
feel
feet
fell
felt
file
fill
film
find
fine
fire
firm
fish
five
flag
flat
flaw
flew
flip
flow
foam
fold
folk
fond
font
food
fool
foot
fork
form
foul
four
free
frog
from
fuel
full
fume
fund
fuse
fuss
gain
game
gang
gasp
gate
gave
gear
gene
gift
girl
give
glad
glow
glue
goal
goat
gold
golf
gone
good
gown
grab
grew
grid
grim
grip
grow
gulf
hack
hail
hair
half
hall
halt
hand
hang
hard
harm
hash
hate
have
hazy
head
heap
hear
heat
heel
held
hell
help
herd
here
hero
hide
high
hill
hint
hire
hold
hole
holy
home
hook
hope
horn
host
hour
huge
hung
hunt
hurt
icon
idea
idle
inch
info
into
iron
item
jack
jail
jazz
jerk
jest
join
joke
jump
junk
jury
just
keen
keep
kept
kick
kill
kind
king
kiss
knee
knew
know
lack
lady
laid
lain
lake
lamp
land
lane
lark
last
late
lawn
lazy
lead
leaf
leak
lean
leap
left
lend
lens
lent
less
lest
lied
life
lift
like
limb
line
link
lion
lisp
list
live
load
loan
lock
logo
long
look
loop
lord
lose
loss
lost
loud
love
luck
lump
lung
lurk
lust
made
mail
main
make
male
many
mark
mask
mass
mate
maze
meal
mean
meat
meet
melt
mend
menu
mere
mess
mice
mild
mile
milk
mill
mind
mine
mint
miss
mist
moan
mock
mode
mole
mood
moon
more
most
move
much
muck
must
myth
nail
name
near
neat
neck
need
nest
next
nice
nick
nine
node
none
noon
norm
nose
note
noun
null
numb
obey
omit
once
only
onto
onus
open
opus
oral
over
owed
pace
pack
page
paid
pain
pair
pale
pant
park
part
pass
past
path
peak
peer
pick
pile
pill
pink
pint
pipe
pity
plan
play
plea
plot
ploy
plug
plus
poem
poet
poke
pole
poll
pool
poor
pope
pork
port
pose
post
pour
pray
pull
pulp
pump
punt
pure
push
putt
quit
quiz
race
rack
rage
raid
rail
rain
rang
rank
rant
rare
rash
rate
rave
read
real
rear
rely
rend
rent
rest
rice
rich
ride
ring
riot
rise
risk
road
rock
rode
role
roll
roof
room
root
rope
rose
rout
rude
ruin
rule
rung
rush
sack
safe
saga
said
sail
sake
sale
salt
same
sand
sane
sang
sank
save
scan
scum
seal
seat
sect
seed
seek
seem
seen
self
sell
send
sent
sexy
shed
ship
shoe
shop
shot
show
shut
sick
side
sigh
sign
sine
sing
sink
site
size
skin
skip
slag
slid
slim
slip
slot
slow
smug
snag
snow
soap
sock
soft
soil
sold
sole
solo
some
song
soon
sore
sort
soul
soup
span
sped
spin
spit
spot
spur
star
stay
stem
step
stir
stop
stun
such
sued
suit
sung
sunk
sure
swam
swap
swim
swum
tack
tail
take
tale
talk
tall
tame
tank
tape
task
taxi
team
tear
tell
tend
term
test
text
than
that
thee
them
then
they
thin
this
thou
thus
tick
tidy
tied
tile
till
time
tiny
tire
toad
told
toll
tome
tone
took
tool
tore
torn
toss
tour
town
trap
tray
tree
trek
trip
true
tube
tune
turn
twin
type
ugly
undo
unit
unto
upon
urge
used
user
vain
vary
vast
vein
vend
verb
very
vice
view
vile
void
vote
wade
wage
wait
wake
walk
wall
want
ward
warm
warn
warp
wary
wash
wave
weak
wear
week
well
went
were
west
what
when
whim
whom
wide
wife
wild
will
wind
wine
wing
wipe
wire
wise
wish
with
wive
woke
wolf
wont
wood
word
wore
work
worm
worn
wrap
wren
yard
yawn
year
yeti
your
zero
zone
zoom`;

/** Legal guesses that are not answers. The full guess list is these plus those. */
export const EXTRA = `abas
abba
abed
abet
ably
abri
abut
aced
aces
ache
achy
acme
acne
acre
acts
acyl
adds
adit
adze
aeon
aero
afar
afto
agar
agee
ages
agha
agio
agma
agog
agon
ague
ahem
ahoy
aide
aids
ails
aims
airs
airt
airy
ajar
akee
alae
alar
alas
alba
albs
alee
ales
alga
alky
alms
aloe
alow
alps
alto
alum
amah
ambo
amen
amid
amie
ammo
amok
amps
amyl
anal
anas
anew
anil
anis
ankh
anna
anoa
anon
anta
ante
anti
ants
anus
aped
apes
apex
apps
apse
aqua
arak
arbs
arcs
ares
aria
arid
aril
arks
arms
arse
arts
arty
arum
arvo
aryl
asci
ashy
asks
asps
atop
auks
aura
auto
aver
avid
avos
avow
awed
awes
awls
awns
awry
axed
axes
axil
axle
axon
ayah
ayes
ayin
azan
baas
baba
babe
bach
bade
bael
bags
baht
bail
bait
bald
bale
balk
balm
banc
bane
bani
bans
bant
baps
barb
bard
barf
barm
barn
bars
bask
bast
bate
bats
batt
bawd
bawl
bays
bead
beak
beau
beck
beds
beep
bees
beet
begs
bels
bema
bens
berg
berk
berm
beth
bets
bevy
beys
bibb
bibs
bice
bide
bids
bier
biff
bike
bile
bilk
bine
bins
bios
birl
birr
bise
bisk
bits
bitt
bize
blab
blag
blah
blat
bleb
bled
blip
bloc
blog
blot
blur
boar
boas
bobs
bock
bode
bods
bogs
bola
bole
boll
bolo
bong
bonk
bony
bonz
boob
boon
boor
boos
bops
bora
borg
bort
bosh
bosk
bots
bott
bour
bows
boxy
boys
bozo
brad
brae
brag
bran
bras
brat
braw
bray
bree
brei
brew
brie
brig
brim
brio
bris
brit
brow
brut
bubo
bubs
buds
buff
bugs
buhl
buhr
bumf
bums
bund
bung
bunk
buns
bunt
buoy
burg
burl
burp
burr
burs
busk
buts
butt
buys
buzz
byes
byre
cabs
cade
cadi
cads
caff
cain
caky
calf
calk
calx
cams
cane
cans
cape
capo
caps
cark
carl
carp
cars
cart
casa
cask
cate
cats
caul
cavy
caws
cays
ceca
cede
cedi
ceil
celt
cere
cero
cess
chad
cham
chaw
chef
chez
chic
chin
chis
chit
choc
chon
chou
chow
chub
chug
chum
ciao
cine
cion
cist
clad
clam
clan
clap
claw
clay
clef
clem
clew
clit
clod
clop
clos
clot
cloy
coax
cobs
coca
cock
coco
coda
cods
coed
coff
cogs
coho
coif
coil
coir
cola
cole
coli
cols
colt
coly
coma
comb
cone
conk
conn
cons
cony
coom
coon
coop
coos
coot
cops
cord
corf
cork
corm
cosh
coss
cosy
cote
coth
cots
coup
cove
cowl
cows
coxa
coze
cozy
crab
crag
cram
crap
craw
cred
cree
crib
croc
crow
crud
crus
crux
csch
cubs
cuds
cued
cues
cuff
cuke
cull
culm
cunt
cups
curb
curd
curl
curs
curt
cusk
cusp
cuss
cuts
cwms
cyan
cyma
cyme
cyst
czar
dabs
dace
dada
dado
dads
daff
dago
dags
dahl
dahs
dais
daks
dale
dame
damn
dams
dang
dank
darg
darn
dart
dato
daub
daws
days
daze
dean
debs
deco
deer
deft
deil
dele
deli
dell
deme
demo
demy
dene
dens
dent
derv
deva
devo
dews
dewy
dhow
dibs
dick
dido
dies
digs
dike
dill
dime
dims
ding
dink
dins
dint
dips
dirk
dits
ditz
diva
dobs
dock
docs
dodo
doer
does
doff
doge
dogs
doit
doll
dols
dolt
dome
dona
dong
dons
dopa
dope
dora
dork
dorm
dorp
dory
dosh
doss
dost
dote
doth
dots
dour
dove
doxy
doze
dozy
drab
dram
drat
dray
dree
dreg
drub
drys
duad
dubs
duce
duct
dude
duds
duel
dues
duet
duke
duma
dune
dung
dunk
duns
dunt
duos
dupe
duro
dusk
dyad
dyed
dyer
dyes
dyke
dyne
earl
ears
eats
eave
ebbs
ebon
echt
ecru
ecus
eddo
eddy
edgy
eels
effs
efts
egad
eggs
egos
eide
eked
ekes
elks
ells
elms
emfs
emir
emos
emus
ends
enol
enow
eons
epos
eras
ergs
erne
errs
ersh
erst
esky
espy
esse
etas
etch
etna
euro
eves
ewer
ewes
exec
exes
exon
expo
eyas
eyed
eyer
eyes
eyot
eyra
eyre
fade
fado
fads
faff
fags
fain
fane
fang
fans
fard
farl
faro
fart
fash
fats
faun
faux
fave
fawn
fays
faze
feal
feck
feds
feer
fees
feme
fend
fens
fere
fern
fess
fest
feta
feud
fiat
fibs
fico
fief
fife
figs
fila
filo
fils
fink
fino
fins
firn
firs
fisc
fist
fits
fizz
flab
flak
flam
flan
flap
flax
flay
flea
fled
flee
flex
fley
flit
floc
floe
flog
flop
flub
flue
flux
foal
fobs
foes
fogs
fogy
foil
foin
fops
forb
ford
fore
fort
fowl
foxy
frae
frag
frap
frat
fray
fret
frig
frit
froe
frow
frug
fuck
fugs
fumy
funk
furl
furs
fury
futz
fuzz
fyke
fyrd
gabs
gaby
gads
gaff
gaga
gags
gait
gala
gale
gall
gals
gamb
gamp
gamy
gape
gaps
garb
gars
gash
gats
gaud
gaur
gawd
gawk
gawp
gays
gaze
gean
geed
geek
gees
geld
gels
gems
gens
gent
genu
germ
gest
gets
geum
ghat
ghee
gibe
gigs
gild
gill
gilt
gimp
gink
gins
gird
giro
girt
gist
gite
gits
glam
glee
glen
gley
glia
glib
glim
glob
glom
glop
glum
glut
gnat
gnaw
gnus
goad
gobo
gobs
goby
gods
goer
goes
goey
gong
goof
gook
goon
goop
gore
gorp
gory
gosh
goth
gout
gowk
goys
grad
gram
gran
gray
gree
grey
grig
grin
grit
grog
grot
grub
grum
guan
guck
guff
guib
gula
gull
gulp
gums
gunk
guns
guru
gush
gust
guts
guvs
guys
gybe
gyms
gyps
gyre
gyro
gyve
haaf
haar
hade
haem
haft
hags
haik
hajj
hake
haku
hale
halm
halo
hame
hams
hank
hare
hark
harl
harp
hart
hasp
hast
hath
hats
haul
hawk
haws
hays
haze
heal
heck
heed
heft
heir
helm
heme
hemp
hems
hens
hent
herb
herl
herm
hern
hers
hest
heth
hews
hick
hied
hies
hike
hila
hilt
hims
hind
hins
hips
hiss
hits
hive
hiya
hoar
hoax
hobo
hobs
hock
hods
hoed
hoer
hoes
hogs
hoke
holm
holp
hols
holt
homo
hone
hong
honk
hons
hood
hoof
hoon
hoop
hoot
hops
hora
hose
hots
hove
howl
hows
hoys
hubs
hued
hues
huff
hugs
hula
hulk
hull
hump
hums
hunk
hurl
hush
husk
huts
hwan
hyla
hymn
hype
hypo
iamb
ibex
ibis
iced
ices
icky
idem
ides
idly
idol
iffy
ilea
ilex
ilia
ilks
ills
imam
impi
imps
inks
inky
inly
inns
inti
ions
iota
iris
irks
isle
isms
itch
iwis
ixia
jabs
jade
jags
jamb
jams
jane
jape
jarl
jars
jato
java
jaws
jays
jean
jeep
jeer
jeez
jefe
jehu
jell
jess
jets
jibe
jibs
jiff
jigs
jill
jilt
jink
jinn
jinx
jiva
jive
jivy
jobs
jock
joey
jogs
john
jolt
jook
josh
joss
jota
jots
jowl
joys
juba
jube
judo
jugs
juju
juke
jura
jute
juts
kadi
kaed
kagu
kaif
kail
kain
kaka
kaki
kale
kali
kame
kami
kana
kaon
kaph
kart
kava
kayo
kcal
keas
keck
keef
keek
keel
kegs
kelp
kelt
keno
kens
kent
kepi
kerb
kerf
kern
kero
keys
khan
khat
kibe
kids
kief
kier
kike
kiln
kilo
kilt
kina
kine
kink
kino
kips
kish
kist
kite
kith
kits
kiva
kiwi
knap
knar
knit
knob
knop
knot
knur
koan
kobo
kobs
koel
kohl
kola
kolo
kook
koph
kors
koto
kris
kudo
kudu
kuna
kyat
kyle
labs
lace
lacy
lade
lads
lags
laic
lair
lakh
laky
lama
lamb
lame
lams
lank
laps
lard
lari
lase
lash
lass
lath
lati
lats
laud
lava
lave
lavs
laws
lays
laze
leal
leas
lech
leek
leer
lees
leet
legs
lehr
leis
leks
leno
lets
leva
levy
lewd
leys
liar
lice
lick
lido
lids
lief
lien
lies
lieu
lilo
lilt
lily
lime
limn
limo
limp
limy
linn
lino
lint
liny
lips
lira
lire
lite
loaf
loam
lobe
lobo
lobs
loci
loco
lode
loft
loge
logs
logy
loin
loll
lone
loom
loon
loos
loot
lope
lops
lore
lorn
lory
lota
loti
lots
loup
lour
lout
lows
luau
lube
luce
ludo
lues
luff
luge
lugs
lull
lulu
lune
lunk
lure
lush
lute
luxe
lwei
lynx
lyre
lyse
mace
macs
mads
mage
magi
mags
maid
maim
mako
mall
malm
malt
mama
mams
mana
mane
mans
maps
mara
marc
mare
marl
mars
mart
mash
mast
math
mats
matt
maul
maun
maws
maxi
maya
mayo
mazy
mead
meed
meek
mega
megs
meld
meme
memo
mems
mene
meow
mesa
mesh
mete
meth
mewl
mews
mhos
mica
mick
mics
midi
mien
miff
mike
milf
milo
mils
milt
mime
mini
mink
minx
mire
mirk
miry
mise
miso
mite
mitt
mize
mkay
moas
moat
mobs
mods
moil
mojo
moke
mola
mold
moll
mols
molt
moly
moms
mong
monk
mono
moor
moos
moot
mope
mops
mora
morn
mort
mosh
moss
mote
moth
mots
moue
mows
moxa
muff
mugs
mule
mull
mump
mums
muon
mure
murk
muse
mush
musk
muss
mute
muts
mutt
muzz
myna
naan
nabs
naff
nags
naif
nana
naos
nape
naps
narc
nard
nark
nary
nave
navy
nays
neap
nebs
neon
nerd
ness
nets
nevi
news
newt
nibs
nide
niff
nigh
nipa
nips
nisi
nits
nobs
nock
nodi
nods
noel
noes
nogs
noil
nolo
noma
nong
nook
nope
nosh
nosy
nous
nova
nowt
nubs
nude
nuke
nuns
nuts
oafs
oaks
oars
oast
oath
oats
obis
obit
oboe
odds
odea
odes
odor
odyl
ofay
offs
ogee
ogle
ogre
ohms
oiks
oils
oily
oink
okas
okay
okra
oleo
oles
olid
olio
olla
omen
omer
ones
onya
onyx
oohs
oops
ooze
oozy
opah
opal
oped
opes
opts
orbs
orca
orcs
ordo
ores
orgy
orle
orts
oryx
orzo
oses
otic
otto
ouch
ours
oust
outs
ouzo
oval
oven
ovum
owes
owls
owns
oxen
oyer
oyez
pact
pacy
pads
pail
pall
palm
palp
pals
paly
pane
pang
pans
papa
paps
pard
pare
parr
pars
pase
pash
pate
pats
pave
pawl
pawn
paws
pays
peag
peal
pean
pear
peas
peat
peba
peck
pecs
peed
peek
peel
peen
peep
pees
pegs
peke
pelf
pelt
peng
pens
pent
peon
peps
peri
perk
perm
pert
perv
peso
pest
pets
pews
phat
phew
phis
phiz
pica
pice
pics
pied
pier
pies
piet
pigs
pika
pike
pili
pily
pimp
pine
ping
pins
pion
pips
pirn
pish
piso
piss
pita
pith
pits
pleb
plod
plop
plow
plum
pock
poco
pods
pogo
pogy
poky
polo
pols
poly
pome
pomp
poms
pond
pone
pong
pons
pony
pood
poof
pooh
poon
poop
poos
pops
pore
porn
posh
posy
pots
pouf
pout
pram
prat
prau
prep
prey
prig
prim
proa
prod
prof
prom
prop
pros
prow
psia
psid
psis
psst
pubs
puca
puce
puck
puds
puff
pugs
puke
pula
pule
puli
puls
puma
pung
punk
puns
puny
pupa
pups
purl
purr
puss
puts
putz
pwns
pyas
pyre
qadi
qoph
quad
quag
quai
quay
quid
quin
quip
quod
racy
rads
raff
raft
raga
ragi
rags
rake
raki
rale
ramp
rams
rand
rape
raps
rapt
rasp
rata
rath
rats
rays
raze
razz
ream
reap
reck
redd
rede
redo
reds
reed
reef
reek
reel
refs
reft
rego
rein
rems
repp
reps
resh
rete
rets
revs
rhea
rhos
rial
ribs
rick
rids
riel
rife
riff
rift
rigs
rile
rill
rime
rims
rimy
rind
rink
ripe
rips
rite
rive
roam
roan
roar
robe
robs
rocs
rods
roes
roil
romp
rood
rook
ropy
rort
rosy
rota
rote
rotl
rots
roup
roux
rove
rows
rube
rubs
ruby
ruck
rudd
rued
rues
ruff
rugs
rump
rums
rune
runs
runt
ruse
rusk
rust
ruth
ruts
ryas
sacs
sage
sago
sags
sain
saki
sans
saps
sard
sari
sash
sass
sate
sati
saws
says
scab
scad
scam
scar
scat
scop
scow
scud
scup
scut
seam
sear
seas
sech
secs
seel
seep
seer
sees
semi
sene
sens
sept
sere
serf
seta
sets
sett
sewn
sews
sext
shad
shag
shah
sham
shaw
shay
sher
shes
shew
shim
shin
shit
shiv
shmo
shod
shoo
shul
shun
sibs
sics
sift
sika
sike
sild
silk
sill
silo
silt
sima
simp
sims
sinh
sins
sips
sire
sirs
sits
skat
skeg
skep
skew
skid
skim
skis
skit
skol
skua
slab
slam
slap
slat
slaw
slay
sled
slew
slit
slob
sloe
slog
slop
slub
slue
slug
slum
slur
slut
smew
smog
smut
snap
snip
snit
snob
snog
snot
snub
snug
soak
soar
soba
sobs
soda
sods
sofa
soke
sola
sols
soma
sone
sons
sook
soot
sops
sora
sorb
sori
sorn
sots
souk
sour
sous
sown
sows
spae
spam
spar
spas
spat
spay
spec
spew
spic
spiv
spry
spud
spue
spun
stab
stag
stet
stew
stoa
stob
stor
stow
stub
stud
subs
suck
sudd
suds
suer
sues
suet
sulk
sumo
sump
sums
sunn
suns
sups
sura
surd
surf
suss
swab
swag
swan
swat
sway
swig
swiz
swot
syce
sync
syne
tabs
tace
tach
taco
tact
tads
tael
tags
tahr
tain
taka
tala
talc
tali
tamp
tams
tana
tang
tanh
tans
taps
tare
tarn
taro
tarp
tars
tart
tass
tats
taus
taut
taws
taxa
teak
teal
teas
teat
teds
teed
teem
teen
tees
tels
temp
tens
tent
terf
tern
teth
thar
thaw
thew
thru
thud
thug
tics
tide
tier
ties
tiff
tiki
tilt
tine
ting
tins
tint
tips
titi
tits
tizz
tody
toea
toed
toes
toff
toft
tofu
toga
togs
toil
toke
tola
tole
tolu
tomb
toms
tong
tons
tony
toot
tope
topi
tops
tori
torr
tors
tort
tosh
tote
tots
tout
tows
toys
trad
tram
tref
tret
trey
trig
trim
trio
trod
trot
trow
troy
trug
tsar
tuba
tubs
tuck
tufa
tuff
tuft
tugs
tums
tuna
tuns
turd
turf
tush
tusk
tuts
tutu
twas
twat
twee
twig
twit
twos
tyke
typo
tyre
tyro
ulna
umps
unis
upas
updo
urea
uric
urns
urus
uses
utes
uvea
vacs
vagi
vail
vair
vale
vamp
vane
vang
vans
vape
vara
vars
vasa
vase
vats
vatu
veal
veep
veer
veil
vela
veld
vena
vent
vest
veto
vets
vial
vibe
vide
vied
vier
vies
vina
vine
vino
viol
vire
visa
vise
vita
viva
vive
voes
vole
volt
vows
wack
wadi
wads
waft
wags
waif
wail
wain
wale
wame
wand
wane
wank
ware
wars
wart
wasp
wast
watt
wavy
waws
waxy
ways
weal
wean
webs
weds
weed
ween
weep
weer
wees
weft
weir
weka
weld
welt
wend
wens
wept
wert
wets
wham
whap
whee
whet
whew
whey
whin
whip
whir
whit
whiz
whoa
whop
whup
whys
wick
wigs
wiki
wile
wilt
wily
wimp
wink
wino
wins
winy
wiry
wisp
wist
wite
wits
woad
woes
wogs
woks
wold
womb
wonk
woof
wool
woop
woos
wops
wort
wove
wows
writ
wuss
wynd
yaks
yams
yang
yank
yaps
yare
yarn
yawl
yawp
yaws
yeah
yean
yeas
yegg
yeld
yell
yelp
yens
yeps
yest
yews
yids
yipe
yips
ylem
yobs
yoga
yogh
yogi
yoke
yolk
yoni
yore
york
yous
yowl
yuan
yuck
yuks
yule
yups
yurt
ywis
zack
zacs
zany
zaps
zarf
zeal
zebu
zeds
zees
zest
zeta
zigs
zinc
zine
zing
zips
ziti
zits
zonk
zoon
zoos`;
